module.exports = __webpack_public_path__ + "media/src/img/payment/visa_logo-5f61c7d2516419bc2652fffe6c4fff65.png";